import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TweenLite} from "gsap";
import {ThorGameAssets} from "../../ThorGameAssets";
import {ThorGameConfig} from "../../ThorGameConfig";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";
import {ThorSoundConfig} from "../../ThorSoundConfig";
import {IconState, IIconView} from "../IIconView";

/**
 * Created by Jerker Nord on 2019-03-22.
 */

export class ThorExtraFSIconView extends BaseView implements IIconView {

    public fsIconIsVisible:boolean = true;

    private static EXTRA_FS_CONTAINER_LANDSCAPE_POSITION:PIXI.Point = new PIXI.Point(1104, 342);
    private static EXTRA_FS_CONTAINER_PORTRAIT_POSITION:PIXI.Point = new PIXI.Point(974, -91);
    public static thorExtraFSIconView:ThorExtraFSIconView;

    private _extraFSIconDisabled:PIXI.Sprite;
    private _extraFSIconEnabled:PIXI.Sprite;
    private _extraFSContainer:PIXI.Container;
    private _layer:ScalableLayer;
    private _state:IconState;
    private _extraFSWonTL:TimelineLite;
    private _fsLeft:number;

    constructor() {
        super();
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.SCATTER_ANIMATION.name);
        this._layer.addChild(this);
        this._extraFSContainer = new PIXI.Container();
        this.addChild(this._extraFSContainer);
        this._state = IconState.disabled;
        ThorExtraFSIconView.thorExtraFSIconView = this;
    }

    protected onResize(resizeData:IResizeData):void {
        if(resizeData.orientation == Orientation.PORTRAIT) {
            this._extraFSContainer.position = ThorExtraFSIconView.EXTRA_FS_CONTAINER_PORTRAIT_POSITION;
            this._extraFSContainer.scale.set(1.2, 1.2);
        } else {
            this._extraFSContainer.position = ThorExtraFSIconView.EXTRA_FS_CONTAINER_LANDSCAPE_POSITION;
            this._extraFSContainer.scale.set(1, 1);
        }
    }

    protected initAnimations():void {
        this._extraFSIconEnabled = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.ICON_MORE_FREESPINS_ENABLED)[0]);
        this._extraFSIconEnabled.anchor.set(0.5, 0.5);
        this._extraFSIconEnabled.position.set(this._extraFSIconEnabled.width / 2, this._extraFSIconEnabled.height / 2);
        this._extraFSContainer.addChild(this._extraFSIconEnabled);
        this._extraFSIconEnabled.alpha = 0;

        this._extraFSIconDisabled = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.ICON_MORE_FREESPINS_DISABLED)[0]);
        this._extraFSContainer.addChild(this._extraFSIconDisabled);
        this._extraFSIconDisabled.alpha = 0;
    }

    public abort():void {
        if(this._extraFSWonTL && this._extraFSWonTL.isActive()) {
            this._extraFSWonTL.pause();
            this._extraFSWonTL.kill();
        }
        this._extraFSIconEnabled.scale.set(1, 1);
        this.setState(IconState.disabled);
    }

    private getFSLeft():number {
        return this._fsLeft;
    }

    public getAwardExtraFSTL(fsLeft:number):TimelineLite {
        this._fsLeft = fsLeft;
        if(this._extraFSWonTL && this._extraFSWonTL.isActive()) {
            this._extraFSWonTL.pause();
            this._extraFSWonTL.kill();
        }
        this._extraFSWonTL = new TimelineLite({});
        this._extraFSWonTL.add(() => this._extraFSIconEnabled.scale.set(1, 1));
        this._extraFSWonTL.add(() => this.setState(IconState.enabled));
        this._extraFSWonTL.add([
            new TweenLite(this._extraFSIconEnabled.scale, 0.4, {x : 1.2, y : 1.2}),
            () => SlotGame.sound.playEffect(ThorSoundConfig.instance.BONUS_EXTRA_FS)
        ]);
        this._extraFSWonTL.add(new TweenLite(this._extraFSIconEnabled.scale, 0.2, {x : 1, y : 1}));
        this._extraFSWonTL.add(() => SlotGame.keypad.setZeroBetSpinCounter(this.getFSLeft() - 1));
        this._extraFSWonTL.add(() => ThorGameModuleConfig.thorFreeSpinBoxView.updateFSNumber(this.getFSLeft() - 1));
        this._extraFSWonTL.add(() => this._extraFSIconEnabled.scale.set(1, 1));
        this._extraFSWonTL.add(new TweenLite(this._extraFSIconEnabled.scale, 0.4, {x : 1.2, y : 1.2}));
        this._extraFSWonTL.add(new TweenLite(this._extraFSIconEnabled.scale, 0.2, {x : 1, y : 1}));
        this._extraFSWonTL.add(() => SlotGame.keypad.setZeroBetSpinCounter(this.getFSLeft()));
        this._extraFSWonTL.add(() => ThorGameModuleConfig.thorFreeSpinBoxView.updateFSNumber(this.getFSLeft()));
        this._extraFSWonTL.add(() => this.setState(IconState.disabled));
        return this._extraFSWonTL;
    }

    /**
     * Starts the icon select animation which will end on extra FS icon
     * @param isFreeSpin
     */
    public getFSIconSelectTL(isFreeSpin:boolean):TimelineLite {
        const timeLine:TimelineLite = new TimelineLite();
        timeLine.add(ThorGameModuleConfig.thorMjolnirtimeView.getIconSelectAnimation(3, isFreeSpin));
        return timeLine;
    }

    /**
     * Fade back FS icon disabled state
     */
    public disableFSIconTL():TimelineLite {
        const timeLine:TimelineLite = new TimelineLite({delay : 1});
        timeLine.add([
            new TweenLite(this._extraFSIconEnabled, 0.4, {alpha : 0}),
            new TweenLite(this._extraFSIconDisabled, 0.2, {alpha : 1})
        ]);
        timeLine.add(() => this.setState(IconState.disabled));
        return timeLine;
    }

    /**
     * Display FS icon at FS start
     */
    public showExtraFSIconTL():void {
        ThorGameModuleConfig.thorReelWildIconView.fsIconIsVisible = true;
        ThorGameModuleConfig.thorRandomWildIconView.fsIconIsVisible = true;
        ThorGameModuleConfig.thorMultiplierIconView.fsIconIsVisible = true;
        this._extraFSIconDisabled.alpha = 1;

    }

    /**
     * Hide FS icon at FS end
     */
    public hideExtraFSIconTL():void {
        this._extraFSIconDisabled.alpha = 0;
        this._extraFSIconEnabled.alpha = 0;
        ThorGameModuleConfig.thorReelWildIconView.fsIconIsVisible = false;
        ThorGameModuleConfig.thorRandomWildIconView.fsIconIsVisible = false;
        ThorGameModuleConfig.thorMultiplierIconView.fsIconIsVisible = false;

    }

    public getState():IconState {
        return this._state;
    }

    public setState(state:IconState):void {
        this._state = state;
        switch(state) {
            case IconState.disabled:
                this._extraFSIconDisabled.alpha = 1;
                this._extraFSIconEnabled.alpha = 0;
                break;
            case IconState.enabled:
                this._extraFSIconDisabled.alpha = 0;
                this._extraFSIconEnabled.alpha = 1;
                break;
            case IconState.activated:
                //Do nothing
                break;
            default:
                debugger;
                throw new Error("IconStates.setState(): Illegal icon state " + state);
        }
    }
}